import axios from 'axios';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
const baseurl = 'ecollection';
export default {
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await axios.post(baseurl, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    inqury(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await axios.post(`${baseurl}/inquiry-ecollection`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    savePaymentVa(data) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post("payment/save-payment-va", data);
                resolve(resp.data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    // list(obj) {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const keys = ['page', 'limit', 'sortBy', 'sortDir', 
    //             'custinfo', 'nomoridentitas', 'npwp', 'PhoneNo', 
    //             'alamatktp', 'City', 'collector_name', 'modified',
    //             'CustCode','CustName','alamtktp'];
    //             let str = '';
    //             for (const key in obj) {
    //                 if (keys.indexOf(key) >= 0 && obj[key]) {
    //                     str += str ? '&' : '?';
    //                     str += key + '=' + encodeURIComponent(obj[key]);
    //                 }
    //             }
    //             const url = `/${baseurl}${str}`;
    //             const { data } = await axios.get(url);
    //             const { meta, list } = data;
    //             obj.total = meta.total;
    //             resolve(list);
    //         } catch (error) {
    //             errorHandler(error, reject)
    //         }
    //     })
    // },
    // exportxls(obj = {}) {
    //     return new Promise((resolve, reject) => {
    //         try {
    //             const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2'];
    //             let str = '';
    //             for (const key in obj) {
    //                 if (keys.indexOf(key) >= 0 && obj[key]) {
    //                     str += str ? '&' : '?';
    //                     str += key + '=' + encodeURIComponent(obj[key]);
    //                 }
    //             }
    //             const url = `/${baseurl}/exportxls/${str}`;
    //             //console.log('#obj exportxls: ',obj);
    //             //console.log('#str exportxls: ',str);
    //             //console.log('#url exportxls: ',url);
    //             axios({
    //                 url: url,
    //                 method: 'GET',
    //                 responseType: 'blob', // important
    //             }).then((response) => {
    //                 console.log("#response: ", response);
    //                 console.log("#response.data: ", response.data);
    //                 const url = window.URL.createObjectURL(new Blob([response.data]));
    //                 const link = document.createElement('a');
    //                 link.href = url;
    //                 link.setAttribute('download', 'masterdebitur.xlsx');
    //                 document.body.appendChild(link);
    //                 link.click();
    //                 // window.location.assign(url);
    //                 resolve(link);
    //             });

    //         } catch (error) {
    //             errorHandler(error, reject)
    //         }
    //     });
    // },

    // exporthistoryxls(obj = {}) {
    //     return new Promise((resolve, reject) => {
    //         try {
    //             const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2'];
    //             let str = '';
    //             for (const key in obj) {
    //                 if (keys.indexOf(key) >= 0 && obj[key]) {
    //                     str += str ? '&' : '?';
    //                     str += key + '=' + encodeURIComponent(obj[key]);
    //                 }
    //             }
    //             const url = `/${baseurl}/exporthistoryxls/${str}`;
    //             axios({
    //                 url: url,
    //                 method: 'GET',
    //                 responseType: 'blob', // important
    //             }).then((response) => {
    //                 //console.log("#response: ", response);
    //                 console.log("#response.data: ", response.data);
    //                 const url = window.URL.createObjectURL(new Blob([response.data]));
    //                 const link = document.createElement('a');
    //                 link.href = url;
    //                 link.setAttribute('download', 'historycollector.xlsx');
    //                 document.body.appendChild(link);
    //                 link.click();
    //                 // window.location.assign(url);
    //                 resolve(link);
    //             });

    //         } catch (error) {
    //             errorHandler(error, reject)
    //         }
    //     });
    // },

    // detail(nasabahkey) {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const { data } = await axios.get(`${baseurl}/detail/${nasabahkey}`);
    //             resolve(data);
    //         } catch (error) {
    //             errorHandler(error, reject)
    //         }
    //     })
    // },

    

    

}